(function () {
    $(document).ready(function () {
        var accordions = $(".panel-group--accordion");

        accordions.each(function () {
            var panel = $(this).find(".panel");
            var panel_title = panel.find(".panel__title button");

            // Collapse all panels except for 1st panel on init
            panel.not(":eq(0)").addClass("panel--collapsed")
                .find(".panel__title button").attr("aria-expanded", "false")  // tell SR trigger is closed
                .end()                                                      // step back up to .panel level
                .find(".panel__content").attr("aria-hidden", "true");      // hide content from SR

            panel_title.click(function () {
                var $panel = $(this).closest(".panel");
                $panel.toggleClass("panel--collapsed");

                // Update aria-expanded attribute based on new state
                var isExpanded = !$panel.hasClass("panel--collapsed");
                $(this).attr("aria-expanded", isExpanded);

                // Update aria-hidden on panel content based on new state
                $panel.find(".panel__content").attr("aria-hidden", !isExpanded);

                return false;
            });
        });
    });
})(this);
